// extracted by mini-css-extract-plugin
export default {"subscription":"ActiveSubscriptionsList_subscription__nRG-W"};